import { render, staticRenderFns } from "./ant-s-t.vue?vue&type=template&id=655ca6cc&scoped=true"
import script from "./ant-s-t.vue?vue&type=script&lang=js"
export * from "./ant-s-t.vue?vue&type=script&lang=js"
import style0 from "./ant-s-t.vue?vue&type=style&index=0&id=655ca6cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655ca6cc",
  null
  
)

export default component.exports